import styled, { css } from "styled-components";
export const Container = styled.div`
  border-radius: 8px;
  background-color: #fff;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 10px;
  margin-top: 20px;
  /* box-shadow: 0 4px 10px 0 rgba(53, 57, 77, 0.4); */
`;
export const OnlinePaymentBtn = styled.div`
  border-radius: 8px;
  background-color: #ffbf1d;
  padding: 2px;
  width: 60%;
  text-align: center;
  color: #fff;
  box-shadow: 0 3px 10px 0 rgba(255, 191, 29, 0.4);
  cursor: pointer;
  margin-top: 20px;
`;
export const OnlinePaymentPrice = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  margin: 15px 0;
  font-weight: bold;
`;
export const Price = styled.div`
  font-size: 16px;
  font-weight: bold;
`;
export const ModalText = styled.div`
  font-size: 16px;
  text-align: center;   
`;
export const Btn = styled.div`
margin-top: 20px;
padding: 5px;
border-radius: 8px;
background-color: #ffbf1d;
color: #fff;
box-shadow: 0 3px 10px 0 rgba(255,191,29,0.4);
cursor: pointer;
`;